import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { Toast } from "primereact/toast";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { useNavigate } from "react-router-dom";
import desiriUserService from "../../services/desiriUser/userservice";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";
import { gannaDTO } from "../../models/oilProduction-model";
import { MultiSelect } from "primereact/multiselect";
import { MenuType } from "../../types/enum";
import { usePageNavigation } from "../user-menu/menu/navigation";
import { useEffect, useRef, useState } from "react";


const OilProductionLog: React.FC = () => {
  const now = new Date();
  const twoHourLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

  const [date, setDate] = useState<Date | null>(new Date());
  const [startTime, setStartTime] = useState<Date>(new Date());
  const [endTime, setEndTime] = useState<Date>(new Date(twoHourLater));
  const [plant, setPlant] = useState<string>("");
  const [manufactureId, setManufactureId] = useState<number | null>(null);
  const [oilseed, setOilseed] = useState<number | null>(null);
  // const [oilseeds, setOilseeds] = useState<{ label: string; value: number }[]>(
  //   []
  // );
  const [oilseeds, setOilseeds] = useState<OilseedOption[]>([]);

  const [vendors, setVendors] = useState<{ label: string; value: number }[]>(
    []
  );
  const navigate = useNavigate();
  const navigateToPage = usePageNavigation();
  const [selectedVendor, setSelectedVendor] = useState<number | null>(null);
  const [vendorInvoices, setVendorInvoices] = useState<any[]>([]);
  const [invoiceOptions, setInvoiceOptions] = useState<InvoiceOption[]>([]);
  const [operators, setOperators] = useState<
    { label: string; value: number }[]
  >([]);
  const [selectedOperator1, setSelectedOperator1] = useState<number | null>(
    null
  );
  const [selectedOperator2, setSelectedOperator2] = useState<number | null>(
    null
  );
  const [bulls, setBulls] = useState<{ label: string; value: number }[]>([]);
  const [selectedBull1, setSelectedBull1] = useState<number | null>(null);
  const [selectedBull2, setSelectedBull2] = useState<number | null>(null);
  const [oilseedWeight, setOilseedWeight] = useState<number | null>(null);
  const [moistureContent, setMoistureContent] = useState<number | null>(null);
  const [gaanaNumber, setGaanaNumber] = useState<number | null>(null);
  const [gaanaName, setgaanaName] = useState<string | null>(null);
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [gaanaOptions, setGaanaOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [selectedInvoice, setSelectedInvoice] = useState<number[]>([]);
  const toast = useRef<Toast>(null);
  const [POSID, setPOSID] = useState(null);
  const [MUOptions, setMUOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const [cakeWeight, setCakeWeight] = useState<number | null>(null);
  const [residueContainerWeight, setResidueContainerWeight] = useState<
    number | null
  >(null);
  const [residueWeight, setResidueWeight] = useState<number | null>(null);
  const [containerAndMaddiWeight, setContainerAndMaddiWeight] = useState<
    number | null
  >(null);
  const [emptyContainerWeight, setEmptyContainerWeight] = useState<
    number | null
  >(null);
  const [maddiWeight, setMaddiWeight] = useState<number | null>(null);
  const [totalWeight, setTotalWeight] = useState<number | null>(null);
  const [containerMaddiWeight, setContainerMaddiWeight] = useState<
    number | null
  >(null);
  const [dailyOutputLitres, setDailyOutputLitres] = useState<number | null>(
    null
  );
  const [inputToOutputRatio, setInputToOutputRatio] = useState<number | null>(
    null
  );
  const [showResidueFields, setShowResidueFields] = useState(false);

  // Add batch state
  const [selectedBatch, setSelectedBatch] = useState<number | null>(null);
  const [invoiceInputMap, setInvoiceInputMap] = useState<InvoiceInput[]>([]);
  const [measurementTypeName, setMeasurementTypeName] = useState<string>("");
  const [submitting, setSubmitting] = useState(false);

  const MIN_OILSEED_WEIGHT = 12;
  const MAX_OILSEED_WEIGHT = 25;

  interface InvoiceInput {
    rawMaterialPurchaseID: number;
    invoiceNumber: string;
    qty: number;
    editable: boolean;
    maxQty: number;
  }


  interface InvoiceOption {
    label: string;
    value: number;
    quantity: number;
    invoiceNumber: string;
  }


  interface OilseedOption {
    label: string;
    value: number;
    measurementTypeName: string;
  }


  // Hardcoded batch options
  const batchOptions = [
    { label: "Batch 1", value: 1 },
    { label: "Batch 2", value: 2 },
    { label: "Batch 3", value: 3 },
    { label: "Batch 4", value: 4 }
  ];

  // Helper function to format date consistently (fixes timezone issue)
  const formatDateForAPI = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };




  // Helper function to parse time string consistently
  const parseTimeString = (timeStr: string) => {
    timeStr = timeStr.trim().toUpperCase();
    if (timeStr.includes(':')) {
      const timeParts = timeStr.split(':');
      let hours = parseInt(timeParts[0]);
      const minutes = parseInt(timeParts[1]);

      if (timeStr.includes('AM') || timeStr.includes('PM')) {
        if (timeStr.includes('PM') && hours < 12) hours += 12;
        if (timeStr.includes('AM') && hours === 12) hours = 0;
      }

      return { hours, minutes };
    }
    return { hours: 8, minutes: 0 };
  };

  // alias function for MU display
  const aliasMU = (id: number, original?: string) => {
    if (id === 3) return "Unit-1-KR";     // K R Nagar
    if (id === 4) return "Unit-2-MT";     // Magadi Taluk
    return original ?? "";
  };

  useEffect(() => {
    const fetchMUOptions = async () => {
      try {
        const response = await oilProductionService.GetMUPlantName();
        if (response && response.length > 0) {
          const formattedOptions = response.map((p: any) => {
            const id = Number(p?.posID ?? p?.PosID ?? p?.POSID ?? p?.id);
            const original =
              p?.address2 ?? p?.Address2 ?? p?.posName ?? p?.PosName ?? "";
            return {
              label: aliasMU(id, original),
              value: id,
            };
          });
          setMUOptions(formattedOptions);
        }
      } catch (error) {
        console.error("Error fetching MU options:", error);
      }
    };

    fetchMUOptions();
  }, []);


  const loadMUDetails = async (posId: number) => {
    if (!date) return;

    try {
      const formattedDate = formatDateForAPI(date);
      const batchNumber = selectedBatch ?? 0;

      const membersResponse =
        await oilProductionService.getBullsAndOperatorsByDate(
          posId,
          formattedDate,
          batchNumber
        );

      if (membersResponse) {
        setOperators(
          membersResponse.operators.map((op: any) => ({
            label: op.name,
            value: op.id,
          }))
        );

        setBulls(
          membersResponse.bulls.map((b: any) => ({
            label: b.name,
            value: b.id,
          }))
        );

        const gaanaList = (membersResponse.gaanaDetails || []).map(
          (g: gannaDTO) => ({
            label: g.gaanaName || "",
            value: g.id,
          })
        );

        setGaanaOptions(gaanaList);

        setGaanaNumber((prev) =>
          prev && gaanaList.some((g) => g.value === prev) ? prev : prev
        );

      }
    } catch (error) {
      console.error("Error loading MU details:", error);
    }
  };


  // UPDATED useEffect: Now includes selectedBatch dependency
  useEffect(() => {
    if (!POSID || !date) return;

    loadMUDetails(POSID);
  }, [POSID, date, selectedBatch]); // ADDED: selectedBatch to dependency array

  useEffect(() => {
    if (!POSID) return;

    const loadOilSeed = async (posId: number) => {
      try {
        const response = await oilProductionService.GetManufacturingunitWiseRawMaterials(posId);

        if (!response || !Array.isArray(response)) {
          console.error("Invalid response for raw materials:", response);
          return;
        }

        // const formatted = response.map((item: any) => ({
        //   label: `${item.rawMaterialName} (${item.currentStock} ${item.measurementTypeName})`,
        //   value: item.rawMaterialId,
        // }));

        const formatted: OilseedOption[] = response.map((item: any) => ({
          label: `${item.rawMaterialName} (${item.currentStock} ${item.measurementTypeName})`,
          value: item.rawMaterialId,
          measurementTypeName: item.measurementTypeName,
        }));


        // Fallback if selected oilseed isn't in the list
        if (oilseed && !formatted.some((f) => f.value === oilseed)) {
          formatted.push({
            label: `Oilseed #${oilseed} (0 ${measurementTypeName || ""})`,
            value: oilseed,
            measurementTypeName: measurementTypeName || "",
          });

        }

        setOilseeds(formatted);
      } catch (error) {
        console.error("Failed to load oilseed types:", error);
      }
    };

    loadOilSeed(POSID);
  }, [POSID]);

  useEffect(() => {
    const fetchMUPlants = async () => {
      try {
        const response = await desiriUserService.getAllMUPlants();
        const formatted = response.map((d: any) => {
          const id = Number(d?.posID ?? d?.PosID ?? d?.POSID ?? d?.id);
          const original =
            d?.posName ?? d?.PosName ?? d?.address2 ?? d?.Address2 ?? "";
          return {
            label: aliasMU(id, original),
            value: id,
          };
        });
        setMUOptions(formatted);
      } catch (error) {
        console.error("Failed to load Manufacturing Units:", error);
      }
    };

    fetchMUPlants();
  }, []);

  const handleBatchChange = async (batchId: number | null) => {
    setSelectedBatch(batchId);

    if (batchId) {
      try {
        const batchTiming = await oilProductionService.getBatchTiming(batchId);
        if (batchTiming && batchTiming.startTime && batchTiming.endTime) {
          const today = new Date();

          const startTimeObj = parseTimeString(batchTiming.startTime);
          const endTimeObj = parseTimeString(batchTiming.endTime);
          const startTimeDate = new Date(today);
          startTimeDate.setHours(startTimeObj.hours, startTimeObj.minutes, 0, 0);

          const endTimeDate = new Date(today);
          endTimeDate.setHours(endTimeObj.hours, endTimeObj.minutes, 0, 0);
          if (endTimeDate <= startTimeDate) {
            endTimeDate.setDate(endTimeDate.getDate() + 1);
          }

          setStartTime(startTimeDate);
          setEndTime(endTimeDate);


        } else {
          console.warn("Invalid batch timing response:", batchTiming);
          toast.current?.show({
            severity: "warn",
            summary: "Warning",
            detail: "No valid timing data found for selected batch",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error fetching batch timing:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load batch timing",
          life: 3000,
        });
      }
    }
  };
  const isInvalidNumber = (val: number | null | undefined) =>
    val === null || val === undefined || isNaN(val) || val <= 0;

  const validateForm = (): boolean => {
    const validations = [
      { cond: !date, msg: "Please select Date" },
      { cond: !POSID, msg: "Please select Manufacturing Unit" },
      { cond: !gaanaNumber, msg: "Please select Gaana Name" },
      { cond: !selectedBatch, msg: "Please select Batch" },
      { cond: !startTime, msg: "Please select Start Time" },
      { cond: !endTime, msg: "Please select End Time" },

      { cond: !oilseed, msg: "Please select Oilseed" },
      { cond: !selectedVendor, msg: "Please select Vendor" },
      { cond: selectedInvoice.length === 0, msg: "Please select Invoice" },

      { cond: oilseedWeight === null || oilseedWeight < MIN_OILSEED_WEIGHT || oilseedWeight > MAX_OILSEED_WEIGHT, msg: `Oilseed Weight must be between ${MIN_OILSEED_WEIGHT} kg and ${MAX_OILSEED_WEIGHT} kg`, },
      { cond: isInvalidNumber(moistureContent), msg: "Please enter Moisture Content" },
      { cond: isInvalidNumber(emptyContainerWeight), msg: "Please enter Empty Container Weight" },

      { cond: !selectedOperator1, msg: "Please select Operator 1" },
      { cond: !selectedBull1, msg: "Please select Bull 1" },

      { cond: isInvalidNumber(cakeWeight), msg: "Please enter Cake Weight" },
      { cond: showResidueFields && residueContainerWeight === null, msg: "Residue Container Weight not calculated" },


      { cond: isInvalidNumber(totalWeight), msg: "Please enter Total Weight" },
      { cond: isInvalidNumber(containerMaddiWeight), msg: "Please enter Container & Maddi Weight" },
      { cond: isInvalidNumber(containerAndMaddiWeight), msg: "Please enter Actual Maddi Weight" },
      { cond: maddiWeight === null, msg: "Maddi Weight not calculated" },
      { cond: dailyOutputLitres === null, msg: "Daily Output not calculated" },
      { cond: inputToOutputRatio === null, msg: "Input to Output Ratio not calculated" },
      { cond: dailyOutputLitres !== null && oilseedWeight !== null && dailyOutputLitres > oilseedWeight, msg: "Total Weight (litres) cannot exceed Oilseed Weight (kg)" },
    ];

    for (const v of validations) {
      if (v.cond) {
        toast.current?.show({
          severity: "error",
          summary: "Validation",
          detail: v.msg,
          life: 3000,
        });
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (submitting) return;
    const isValid = validateForm();
    if (!isValid) return;

    setSubmitting(true);

    const rawMaterialPurchaseList = invoiceInputMap.map(inv => ({
      rawMaterialPurchaseID: inv.rawMaterialPurchaseID,
      invoiceNumber: inv.invoiceNumber,
      oilSeedWeight: inv.qty
    }));


    const intakeLog = {
      rawMaterialPurchases: rawMaterialPurchaseList,
      posID: POSID ?? 0,
      vendorID: selectedVendor,            // <-- add vendorId
      // invoiceNumber: selectedInvoice?.invoiceNumber ?? "", // <-- add invoiceNumber
      // FIXED: Use consistent date formatting to avoid timezone issues
      submittedDate: date ? formatDateForAPI(date) : null,
      startTime: startTime?.toTimeString().split(" ")[0] ?? null,
      endTime: endTime?.toTimeString().split(" ")[0] ?? null,
      gaanaID: gaanaNumber ?? 0,
      oilSeedID: oilseed ?? 0,
      oilSeedWeight: oilseedWeight ?? 0,
      moistureContent: moistureContent ?? 0,
      emptyContainerWeightKG: emptyContainerWeight ?? 0,
      operator1ID: selectedOperator1 ?? 0,
      operator2ID: selectedOperator2 ?? null,
      bull1ID: selectedBull1 ?? 0,
      bull2ID: selectedBull2 ?? null,
      batch: selectedBatch ?? 0,
    };

    const processingOutput = {
      totalOilWeightWithContainerKG: totalWeight ?? 0,
      containerAndBottomMaddiWeight: containerAndMaddiWeight ?? 0,
      maddiWeightWithContainer: containerMaddiWeight ?? 0,
      maddiWeight: maddiWeight ?? 0,
      byProductID: 1,
      dailyOutputLitres: dailyOutputLitres ?? 0,
      inputToOutputRatio: inputToOutputRatio ?? " ",
      capacityLossReason: "",
    };

    const cakeOutput = {
      cakeWeightKG: cakeWeight ?? 0,
      residueContainerWeightKG: residueContainerWeight ?? 0,
      residueWeightKG: residueWeight ?? 0,
      byProductID: 1,
    };

    const payload = {
      intakeLog,
      processingOutput,
      cakeOutput,
    };
    try {
      const result = await oilProductionService.addOilIntakeLog(payload);
      if (result && result.isSuccess) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: result.message || "Oil Intake Log saved successfully",
          life: 3000,
        });
        navigateToPage(MenuType.OilProductionRecords);
        setDate(new Date());
        setStartTime(new Date());
        setEndTime(new Date(new Date().getTime() + 2 * 60 * 60 * 1000));
        setOilseed(null);
        setSelectedVendor(null);
        setSelectedInvoice([]);
        setOilseedWeight(null);
        setMoistureContent(null);
        setEmptyContainerWeight(null);
        setGaanaNumber(null);
        setSelectedOperator1(null);
        setSelectedOperator2(null);
        setSelectedBull1(null);
        setSelectedBull2(null);
        setVendors([]);
        setInvoiceOptions([]);
        setVendorInvoices([]);
        setDailyOutputLitres(null);
        setInputToOutputRatio(null);
        setSelectedBatch(null);
        setCakeWeight(null);
        setResidueContainerWeight(null);
        setResidueWeight(null);
        setEndTime(new Date());
        setDailyOutputLitres(null);
        setInputToOutputRatio(null);
        setCakeWeight(null);
        setResidueContainerWeight(null);
        setResidueWeight(null);
        setTotalWeight(null);
        setContainerMaddiWeight(null);
        setContainerMaddiWeight(null);
        setContainerAndMaddiWeight(null);
      } else {
        // Show error message from backend
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: result?.message || "Failed to save oil intake log",
          life: 5000,
        });
      }
    } catch (error: any) {
      // Handle error response from backend
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to save oil intake log";
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 5000,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const calculateResidue = (cake: number | null, container: number | null) => {
    if (cake != null && container != null) {
      const result = cake - container;
      setResidueWeight(result >= 0 ? parseFloat(result.toFixed(2)) : 0);
    } else {
      setResidueWeight(null);
    }
  };

  const calculateMaddiWeight = (
    containerMaddi: number | null,
    empty: number | null
  ) => {
    if (containerMaddi != null && empty != null) {
      const result = containerMaddi - empty;
      setMaddiWeight(result >= 0 ? parseFloat(result.toFixed(2)) : 0);
    } else {
      setMaddiWeight(null);
    }
  };

  const calculateInputToOutputRatio = (
    output: number | null,
    input: number | null
  ) => {
    if (output != null && input != null && input > 0) {
      const ratio = output / input;
      setInputToOutputRatio(ratio);
    } else {
      setInputToOutputRatio(null);
    }
  };

  const calculateDailyOutput = (total: number | null, maddi: number | null) => {
    if (total != null && maddi != null) {
      const difference = total - maddi;
      const output =
        difference > 0 ? Math.floor((difference / 0.93) * 100) / 100 : 0;
      setDailyOutputLitres(output);
      calculateInputToOutputRatio(output, oilseedWeight);
    } else {
      setDailyOutputLitres(null);
      setInputToOutputRatio(null);
    }
  };

  const fieldHoverStyle = (fieldName: string, disabled?: boolean) => ({
    border: hoveredField === fieldName ? "2px solid #43447cff" : "1px solid #ced4da",
    boxShadow: hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
    backgroundColor: disabled ? "#ccbcbcff" : "#f9f9f9",
    color: disabled ? "#555" : "#000",
  });

  // Function to handle start time change and automatically update end time
  const handleStartTimeChange = (selectedTime: Date | null) => {
    if (!selectedTime) return;

    setStartTime(selectedTime);

    // Automatically set end time to 2 hours after start time
    const newEndTime = new Date(selectedTime.getTime() + 2 * 60 * 60 * 1000);
    setEndTime(newEndTime);
  };

  // Function to handle end time change with validation
  const handleEndTimeChange = (selectedTime: Date | null) => {
    if (!selectedTime) return;

    // Prevent end time from being before or equal to start time
    if (selectedTime <= startTime) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "End time must be after start time",
        life: 3000,
      });

      // Set end time to at least 15 minutes after start time
      const minimumEndTime = new Date(startTime.getTime() + 15 * 60 * 1000);
      setEndTime(minimumEndTime);
    } else {
      setEndTime(selectedTime);
    }
  };
  useEffect(() => {
    if (
      totalWeight !== null &&
      containerMaddiWeight !== null &&
      totalWeight > containerMaddiWeight
    ) {
      const output = Math.floor(
        ((totalWeight - containerMaddiWeight) / 0.93) * 100
      ) / 100;

      setDailyOutputLitres(output);

      if (oilseedWeight && oilseedWeight > 0) {
        setInputToOutputRatio(output / oilseedWeight);
      }
    } else {
      setDailyOutputLitres(null);
      setInputToOutputRatio(null);
    }
  }, [totalWeight, containerMaddiWeight, oilseedWeight]);

  const handleMUChange = (newMU: any) => {
    setPOSID(newMU);
    if (!newMU) return;

    setGaanaNumber(null);
    setSelectedBatch(null);

    const resetTime = new Date();
    resetTime.setHours(0, 0, 0, 0);
    setStartTime(resetTime);
    setEndTime(resetTime);

    setOilseed(null);
    setSelectedVendor(null);
    setSelectedInvoice([]);
    setInvoiceInputMap([]);
    setOilseedWeight(null);
    setSelectedOperator1(null);
    setSelectedOperator2(null);
    setSelectedBull1(null);
    setSelectedBull2(null);

    setMoistureContent(null);
    setEmptyContainerWeight(null);
    setCakeWeight(null);
    setTotalWeight(null);
    setContainerAndMaddiWeight(null);
    setResidueContainerWeight(null);
    setResidueWeight(null);
    setContainerMaddiWeight(null);
    setMaddiWeight(null);
    setDailyOutputLitres(null);
    setInputToOutputRatio(null);

    setVendors([]);
    setInvoiceOptions([]);
    setVendorInvoices([]);
  };

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <div>
        <div
          className="add-button-container border-round font-bold ml-3 text-primary"
          style={{ textAlign: "left" }}
        >
          <div></div>
        </div>

        <div className="p-card p-4 shadow-lg rounded-lg bg-white mt-2">
          <div className="grid">
            <div className="col-12 mb-2">
              <div className="grid">
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Date
                    <span className="required">*</span>
                  </label>
                  <Calendar
                    value={date}
                    onChange={(e) => setDate(e.value as Date)}
                    className="w-full"
                    style={fieldHoverStyle("description")}
                    dateFormat="dd-mm-yy"
                    readOnlyInput
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Manufacturing Unit<span className="required">*</span>
                  </label>

                  <Dropdown
                    value={POSID}
                    options={MUOptions}
                    onChange={(e) => handleMUChange(e.value)}
                    placeholder="Select Manufacturing Unit"
                    style={fieldHoverStyle("description", false)}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Gaana Name<span className="required">*</span>
                  </label>

                  <Dropdown
                    value={gaanaNumber} // selected gaana id
                    options={gaanaOptions} // options with label=gaanaName
                    onChange={(e) => setGaanaNumber(e.value)}
                    placeholder="Select Gaana Name"
                    className="w-full"
                    style={fieldHoverStyle("description", false)}
                  />
                </div>

                {/* Add Batch Dropdown Here */}
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Batch <span className="required">*</span>
                  </label>
                  <Dropdown
                    value={selectedBatch}
                    options={batchOptions}
                    onChange={(e) => handleBatchChange(e.value)}
                    placeholder="Select Batch"
                    style={fieldHoverStyle("description", false)}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Start Time<span className="required">*</span>
                  </label>
                  <Calendar
                    readOnlyInput
                    value={startTime}
                    onChange={(e) => handleStartTimeChange(e.value as Date)}
                    timeOnly
                    hourFormat="12"
                    stepMinute={15}
                    className="w-full"
                    style={fieldHoverStyle("description", false)}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    End Time<span className="required">*</span>
                  </label>
                  <Calendar
                    readOnlyInput
                    value={endTime}
                    onChange={(e) => handleEndTimeChange(e.value as Date)}
                    timeOnly
                    hourFormat="12"
                    stepMinute={15}
                    className="w-full"
                    style={fieldHoverStyle("description", false)}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 mt-1">
              <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
              <div className="grid">

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Oilseed Name<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={oilseed}
                    options={oilseeds}
                    onChange={async (e) => {
                      const selectedOilseedId = e.value;
                      setOilseed(selectedOilseedId);



                      //const selected = oilseeds.find(o => o.value === selectedOilseedId);
                      const selected = oilseeds.find(o => o.value === selectedOilseedId);
                      const unit = selected?.measurementTypeName || "";

                      setMeasurementTypeName(unit);

                      if (selected) {
                        setMeasurementTypeName(selected.measurementTypeName);
                      }

                      setSelectedVendor(null);
                      setSelectedInvoice([]);
                      setInvoiceInputMap([]);
                      setOilseedWeight(null);
                      setInvoiceOptions([]);
                      setVendors([]);

                      setMoistureContent(null);
                      setEmptyContainerWeight(null);
                      setCakeWeight(null);
                      setTotalWeight(null);
                      setContainerAndMaddiWeight(null);
                      setResidueContainerWeight(null);
                      setResidueWeight(null);
                      setContainerMaddiWeight(null);
                      setMaddiWeight(null);
                      setDailyOutputLitres(null);
                      setInputToOutputRatio(null);
                      setSelectedOperator1(null);
                      setSelectedOperator2(null);
                      setSelectedBull1(null);
                      setSelectedBull2(null);

                      try {
                        // Call new API
                        const payload = {
                          rawMaterialId: selectedOilseedId,
                          posId: POSID,   // Pass POSID also
                        };

                        const response = await RawMaterialService.GetVendorandInvoiceWiseQty(payload);

                        if (response && Array.isArray(response)) {
                          // Format vendors
                          const formattedVendors = response.map((vendor: any) => ({
                            // label: `${vendor.vendorName} (${vendor.totalQuantity} kg)`,
                            //label: `${vendor.vendorName} (${vendor.totalQuantity} ${measurementTypeName})`,
                            label: `${vendor.vendorName} (${vendor.totalQuantity} ${unit})`,

                            value: vendor.vendorId,
                            invoices: vendor.invoices, // Keep for later
                          }));

                          setVendors(formattedVendors);
                          setVendorInvoices(response);
                          setSelectedVendor(null);
                          setInvoiceOptions([]);
                          setSelectedInvoice([]);
                        }
                      } catch (err) {
                        console.error("Error fetching vendors & invoices:", err);
                      }
                    }}
                    placeholder="Select Oilseed Name"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Vendor Name<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={selectedVendor}
                    options={vendors}
                    onChange={(e) => {
                      const selectedVendorId = e.value;
                      setSelectedVendor(selectedVendorId);

                      setSelectedInvoice([]);
                      setInvoiceInputMap([]);
                      setOilseedWeight(null);

                      const vendor = vendorInvoices.find(
                        (v) => v.vendorId === selectedVendorId
                      );

                      if (vendor && vendor.invoices) {
                        const formattedInvoices: InvoiceOption[] = vendor.invoices.map((inv: any) => ({
                          // label: `${inv.invoiceNumber} - ${inv.quantity} kg`,
                          label: `${inv.invoiceNumber} - ${inv.quantity} ${measurementTypeName}`,

                          value: Number(inv.rawMaterialPurchaseId),
                          quantity: Number(inv.quantity),
                          invoiceNumber: inv.invoiceNumber,
                        }));

                        setInvoiceOptions(formattedInvoices);

                        setSelectedInvoice([]);
                      }
                    }}
                    placeholder="Select Vendor Name"
                    className="w-full"
                  />
                </div>

                <div className="field col-12 md:col-2">
                  <label className="label-semi-bold">
                    Vendor Invoice Number<span className="required">*</span>
                  </label>
                  <MultiSelect
                    value={selectedInvoice}
                    options={invoiceOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Vendor Invoice Number"
                    display="chip"
                    className="w-full"
                    onChange={(e) => {
                      const selectedIds = e.value as number[];

                      if (selectedIds.length === 0) {
                        setSelectedInvoice([]);
                        setInvoiceInputMap([]);
                        setOilseedWeight(null);
                        return;
                      }

                      setInvoiceInputMap((prev) => {
                        const updated: InvoiceInput[] = selectedIds.map((id) => {
                          const existing = prev.find(
                            (p) => p.rawMaterialPurchaseID === id
                          );

                          if (existing) {
                            return existing;
                          }

                          const inv = invoiceOptions.find((i) => i.value === id)!;

                          return {
                            rawMaterialPurchaseID: inv.value,
                            invoiceNumber: inv.invoiceNumber,
                            qty: inv.quantity,
                            maxQty: inv.quantity,
                            editable: true,
                          };
                        });

                        const total = Number(
                          updated.reduce((sum, x) => sum + x.qty, 0).toFixed(2)
                        );

                        setOilseedWeight(total);
                        return updated;
                      });

                      setSelectedInvoice(selectedIds);
                    }}
                  />


                  {invoiceInputMap.length > 0 && (
                    <div className="mt-2">
                      <label className="label-semi-bold">
                        Selected Invoice Quantity
                      </label>

                      <div className="flex gap-3 mt-2 flex-wrap">
                        {invoiceInputMap.map((inv) => (
                          <div
                            key={inv.rawMaterialPurchaseID}

                            className="p-inputgroup"
                            style={{
                              width: "320px",
                              flexWrap: "nowrap",
                            }}
                          >

                            <span
                              className="p-inputgroup-addon"
                              style={{
                                minWidth: "90px",
                                justifyContent: "center",
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {inv.invoiceNumber}
                            </span>

                            <InputNumber
                              value={inv.qty}
                              min={0}
                              max={inv.maxQty}
                              step={0.01}
                              mode="decimal"
                              minFractionDigits={2}
                              inputStyle={{ textAlign: "right", width: "100%" }}

                              onChange={(e) => {
                                let value = e.value ?? 0;

                                // ❌ Block negative values
                                if (value < 0) {
                                  value = 0;
                                  toast.current?.show({
                                    severity: "warn",
                                    summary: "Invalid Quantity",
                                    detail: "Quantity cannot be negative",
                                    life: 2000,
                                  });
                                }

                                // ❌ Block more than invoice max
                                if (value > inv.maxQty) {
                                  value = inv.maxQty;
                                  toast.current?.show({
                                    severity: "warn",
                                    summary: "Invalid Quantity",
                                    detail: `Maximum allowed for this invoice is ${inv.maxQty}`,
                                    life: 2000,
                                  });
                                }

                                setInvoiceInputMap((prev) => {
                                  // Update only the edited invoice
                                  const updated = prev.map((p) =>
                                    p.rawMaterialPurchaseID === inv.rawMaterialPurchaseID
                                      ? { ...p, qty: value }
                                      : p
                                  );

                                  // 🔢 Calculate TOTAL oilseed weight
                                  const total = Number(
                                    updated.reduce((sum, x) => sum + x.qty, 0).toFixed(2)
                                  );

                                  setOilseedWeight(total);

                                  calculateInputToOutputRatio(dailyOutputLitres, total);
                                  // ❌ Total must be > 0
                                  if (total === 0) {

                                    toast.current?.show({
                                      severity: "warn",
                                      summary: "Invalid Total Quantity",
                                      detail: `Invoice quantity must be greater than zero`,
                                      life: 2000,
                                    });
                                  }
                                  // ❌ Below minimum
                                  else if (total < MIN_OILSEED_WEIGHT) {

                                    toast.current?.show({
                                      severity: "warn",
                                      summary: "Invalid Total Quantity",
                                      detail: `Total oilseed weight must be at least ${MIN_OILSEED_WEIGHT} kg`,
                                      life: 2000,
                                    });
                                  }
                                  // ❌ Above maximum
                                  else if (total > MAX_OILSEED_WEIGHT) {


                                    toast.current?.show({
                                      severity: "warn",
                                      summary: "Invalid Total Quantity",
                                      detail: `Total oilseed weight cannot exceed ${MAX_OILSEED_WEIGHT} kg`,
                                      life: 2000,
                                    });
                                  }
                                  // ✅ Valid total
                                  else {

                                  }

                                  return updated;
                                });
                              }}

                              onKeyDown={(e) => {
                                // ❌ Block scientific notation & signs
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />


                            <span
                              className="p-inputgroup-addon"
                              style={{
                                minWidth: "45px",
                                justifyContent: "center",
                                whiteSpace: "nowrap",
                              }}
                            >
                              kg
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Oilseed Weight (kg)<span className="required">*</span>
                  </label>
                  <InputNumber
                    value={oilseedWeight}
                    disabled
                    mode="decimal"
                    minFractionDigits={2}
                    className="w-full"
                    style={fieldHoverStyle("description", true)}
                  />

                </div>

                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Moisture Content (%)<span className="required">*</span>
                  </label>
                  <InputNumber
                    value={moistureContent}
                    onValueChange={(e) => setMoistureContent(e.value ?? null)}
                    placeholder="Enter Moisture content"
                    mode="decimal"
                    minFractionDigits={2}
                    step={0.01}
                    useGrouping={false}
                    className="w-full"
                    style={fieldHoverStyle("description", false)}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={8}
                  />
                </div>
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Empty Container Weight (Kg)
                    <span className="required">*</span>
                  </label>
                  <InputNumber
                    value={emptyContainerWeight}
                    onChange={(e) => {
                      const val = e.value ?? null;
                      setEmptyContainerWeight(val);
                      if (val !== null) {
                        const standardContainerMaddi = parseFloat((val + 0.3).toFixed(2));
                        setContainerMaddiWeight(standardContainerMaddi);
                        setResidueContainerWeight(standardContainerMaddi);

                        calculateResidue(cakeWeight, standardContainerMaddi);
                        calculateDailyOutput(totalWeight, standardContainerMaddi);
                        calculateMaddiWeight(containerAndMaddiWeight, val);
                      } else {
                        setContainerMaddiWeight(null);
                        setResidueContainerWeight(null);
                        setResidueWeight(null);
                        setMaddiWeight(null);
                      }
                    }}
                    placeholder="Enter Empty Container Weight"
                    mode="decimal"
                    minFractionDigits={2}
                    step={0.01}
                    useGrouping={false}
                    className="w-full"
                    style={fieldHoverStyle("emptyContainerWeight", false)}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={8}
                  />
                </div>

                <div className="col-12 mt-2">
                  <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
                  <div className="grid">
                    <div className="field col-12 md:col-3">
                      <label className="label-semi-bold">
                        Cake Weight <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={cakeWeight}
                        onChange={(e) => {
                          const val = e.value ?? null;
                          setCakeWeight(val);
                          calculateResidue(val, residueContainerWeight);
                        }}
                        placeholder="Enter Cake Weight"
                        mode="decimal"
                        minFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("cakeWeight", false)}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>

                    <div className="field col-12 md:col-3" style={{ paddingRight: "0" }}>
                      <div style={{ display: "flex", alignItems: "flex-start", gap: "0" }}>
                        <button
                          type="button"
                          onClick={() => setShowResidueFields(!showResidueFields)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "1.3rem",
                            color: showResidueFields ? "#43447cff" : "#999",
                            padding: "0.5rem 0.3rem 0 0",
                            marginRight: "0",
                            flexShrink: 0
                          }}
                          title={showResidueFields ? "Hide residue fields" : "Show residue fields"}
                        >
                          <i className={`pi ${showResidueFields ? "pi-eye" : "pi-eye-slash"}`} />
                        </button>

                        {showResidueFields && (
                          <div style={{ flex: 1, paddingLeft: "0.3rem" }}>
                            <label className="label-semi-bold" style={{ display: "block", marginBottom: "0.5rem" }}>
                              Residue Container Weight{" "}
                              <span className="required">*</span>
                            </label>
                            <InputNumber
                              value={residueContainerWeight}
                              disabled
                              onChange={(e) => {
                                const val = e.value ?? null;
                                setResidueContainerWeight(val);
                                calculateResidue(cakeWeight, val);
                              }}
                              placeholder="Enter Residue Container Weight"
                              mode="decimal"
                              minFractionDigits={2}
                              className="w-full"
                              style={fieldHoverStyle("residueContainerWeight", true)}
                              onKeyDown={(e) => {
                                // block e, E, +, -
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {showResidueFields && (
                      <div className="field col-12 md:col-3">
                        <label className="label-semi-bold">
                          Residue Weight <span className="required">*</span>
                        </label>
                        <InputNumber
                          value={residueWeight}
                          disabled
                          placeholder="Residue Weight"
                          mode="decimal"
                          minFractionDigits={2}
                          // step={0.01}
                          useGrouping={false}
                          className="w-full"
                          style={fieldHoverStyle("residueWeight", true)}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12 mt-2">
                  <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
                  <div className="grid">
                    <div className="field col-12 md:col-3">
                      <label
                        className="label-semi-bold"
                        style={{
                          whiteSpace: "normal",
                          display: "block",
                          lineHeight: "2",
                        }}
                      >
                        Total Weight (Container + Oil) (Kg)
                        <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={totalWeight}
                        onChange={(e) => {
                          setTotalWeight(e.value ?? null);
                        }}
                        placeholder="Enter Total Weight (Container + Oil)"
                        mode="decimal"
                        minFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("totalWeight")}
                        maxLength={8}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>

                    <div className="field col-12 md:col-3">
                      <label
                        className="label-semi-bold"
                        style={{
                          whiteSpace: "normal",
                          display: "block",
                          lineHeight: "1",
                        }}
                      >
                        Standard Container with Bottom Maddi Weight (Kg)
                        <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={containerMaddiWeight}
                        disabled
                        placeholder="Enter Container with Bottom Maddi Weight (Kg)"
                        mode="decimal"
                        minFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("containerMaddiWeight", true)}
                        maxLength={8}
                      />
                    </div>

                    <div className="field col-12 md:col-3">
                      <label
                        className="label-semi-bold"
                        style={{
                          whiteSpace: "normal",
                          display: "block",
                          lineHeight: "2",
                        }}
                      >
                        Daily Output in litres
                        <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={dailyOutputLitres}
                        disabled
                        placeholder="Daily Output in litres"
                        mode="decimal"
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("dailyOutputLitres", true)}
                        maxLength={8}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 mt-2">
                  <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
                  <div className="grid">
                    <div className="field col-12 md:col-3">
                      <label className="label-semi-bold">
                        Actual Maddi Weight with Container
                        <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={containerAndMaddiWeight}
                        onChange={(e) => {
                          const val = e.value ?? null;
                          setContainerAndMaddiWeight(val);
                          calculateMaddiWeight(val, emptyContainerWeight);
                        }}
                        placeholder="Enter Maddi Weight with Container"
                        mode="decimal"
                        minFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("description")}
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        maxLength={8}
                      />
                    </div>
                    <div className="field col-12 md:col-3">
                      <label className="label-semi-bold">
                        Maddi Weight
                        <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={maddiWeight}
                        disabled
                        placeholder="Maddi Weight"
                        mode="decimal"
                        minFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("maddiWeight", true)}
                        maxLength={8}
                      />
                    </div>

                    <div className="field col-12 md:col-3">
                      <label className="label-semi-bold">
                        Input to Output Ratio
                        <span className="required">*</span>
                      </label>
                      <InputNumber
                        value={
                          inputToOutputRatio !== null
                            ? inputToOutputRatio * 100
                            : undefined
                        }
                        disabled
                        placeholder="Input to Output Ratio"
                        mode="decimal"
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        step={0.01}
                        useGrouping={false}
                        className="w-full"
                        style={fieldHoverStyle("inputToOutputRatio", true)}
                        maxLength={8}
                        suffix="%"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 mt-2">
              <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
              <div className="grid">
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Operator 1<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={selectedOperator1}
                    options={operators.filter(
                      (op) => op.value !== selectedOperator2
                    )}
                    onChange={(e) => setSelectedOperator1(e.value)}
                    placeholder="Select Operator 1"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">Operator 2</label>
                  <Dropdown
                    value={selectedOperator2}
                    options={operators.filter(
                      (op) => op.value !== selectedOperator1
                    )}
                    onChange={(e) => setSelectedOperator2(e.value)}
                    placeholder="Select Operator 2"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">
                    Bull Name 1<span className="required">*</span>
                  </label>
                  <Dropdown
                    value={selectedBull1}
                    options={bulls.filter((op) => op.value !== selectedBull2)}
                    onChange={(e) => setSelectedBull1(e.value)}
                    placeholder="Select Bull Name 1"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>
                <div className="field col-12 md:col-3">
                  <label className="label-semi-bold">Bull Name 2</label>
                  <Dropdown
                    value={selectedBull2}
                    options={bulls.filter((op) => op.value !== selectedBull1)}
                    onChange={(e) => setSelectedBull2(e.value)}
                    placeholder="Select Bull Name 2"
                    className="w-full"
                    style={fieldHoverStyle("description")}
                  />
                </div>
              </div>
            </div>
            <div className="field col-12 text-center mt-4">
              <Button label="Submit" onClick={handleSubmit} disabled={submitting} loading={submitting} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OilProductionLog;